var error = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof styleguide !== "undefined") return resolve();
	__webpack_require__.l("https://unpkg.com/@brockreece/test-styleguide@0.1.1/dist/remoteEntry.js", function(event) {
		if(typeof styleguide !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		error.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		error.name = 'ScriptExternalLoadError';
		error.type = errorType;
		error.request = realSrc;
		reject(error);
	}, "styleguide");
}).then(function() { return styleguide; });